import { RequestStatus } from 'clickNgo/configs/service/common'
import { IFinSobSidePanelState } from 'partner360/features/finSobSidePanel/models/state'

export const initialState: IFinSobSidePanelState = {
  data: {},
  fetchStatus: RequestStatus.NONE,
  selectedItem: {},
  categoryWithLoadingCompletenessStatus: null,
}
